// extracted by mini-css-extract-plugin
module.exports = {"row":"TableMobileRow_row__3PUB3","titre":"TableMobileRow_titre__3N1QI"};